import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { Location } from 'src/app/models/location.model';
import { PhoneFormatPipe } from 'src/app/pipes/phone-format.pipe';
import { LocationService } from '@services/location.service';

@Component({
  selector: 'app-location-contact-info',
  standalone: true,
  templateUrl: './location-contact-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NzButtonModule, NzIconModule, NzDividerModule, TranslateModule, PhoneFormatPipe, NzTypographyComponent],
})
export class LocationContactInfoComponent {
  location$: Observable<Location>;

  constructor(private locationService: LocationService) {
    this.location$ = this.locationService.locationChanged.pipe(startWith(this.locationService.getLocation()));
  }
}
